import { computed } from 'vue';

import { type PlatformSellingMethod } from '~/types/sale.type';

export const useSlpSellingMethod = (): ComputedRef<PlatformSellingMethod> => {
    const routeBaseName = useRouteBaseName();
    const route = useRoute();

    return computed(() => {
        const routeName = routeBaseName(route);

        if (!isSlpRoute(routeName)) {
            throw Error('useSlpSellingMethod has been called outside slp route');
        }

        return getSellingMethodFromRouteName(routeName);
    });
};
